<!-- src/components/filters/CurrentMaFilter.vue -->
<template>
  <NumberRangeFilter field="current_ma" label="Ток (mA)" @filter="$emit('filter',$event)" :initialRange="initialRange"/>
</template>

<script>
import NumberRangeFilter from './NumberRangeFilter.vue'
export default {
  name: 'CurrentMaFilter',
  components: { NumberRangeFilter },
  props: {
    initialRange: { type: Array, default: () => [] }
  }
}
</script>
